import { createAction, handleActions } from "redux-actions"
import { apiDelete, apiGet, apiPost, apiPut } from "../utils/apiConnector"
import { employeeApi, getEmplInfoApi } from "../config/apiUrls"
import { alertTypes, showMessage } from "./alerts"

// Default state
const defaultState = {
  isLoading: false,
  employees: [],
  loadingEmployeeIds: [],
  currentEmployee: {},
  emplData: {},
}

// Action Creators
const saveCurrent = createAction("SAVE_CURRENT_EMPLOYEE")
/// setLoading(flag)
const setLoading = createAction("SET_EMPLOYEES_FETCHING")
/// setEmployees(employees)
const setEmployees = createAction("SET_EMPLOYEES")
const edited = createAction("EDIT_EMPLOYEE")
/// removeEmployee(employeeId)
const removeEmployee = createAction("REMOVE_EMPLOYEE")
/// setEmployeeLoading(employeeId)
const setEmployeeLoading = createAction("SET_EMPLOYEE_LOADING", (id, flag) => ({
  id,
  flag,
}))
const isExist = createAction("IS_EXISt ")

// Reducer
const reducer = handleActions(
  {
    [saveCurrent]: (state, { payload }) => ({
      ...state,
      currentEmployee: payload,
    }),
    [setLoading]: (state, { payload }) => ({ ...state, isLoading: payload }),
    [setEmployees]: (state, { payload }) => ({ ...state, employees: payload }),
    [edited]: (state) => ({ ...state }),
    [removeEmployee]: (state, { payload }) => ({
      ...state,
      employees: state.employees.filter((e) => e.employeeId !== payload),
    }),
    [isExist]: (state, { payload }) => ({
      ...state,
      emplData: { ...payload },
    }),
    [setEmployeeLoading]: (state, { payload: { id, flag } }) => {
      if (flag) {
        return {
          ...state,
          loadingEmployeeIds: [...state.loadingEmployeeIds, id],
        }
      } else {
        return {
          ...state,
          loadingEmployeeIds: state.loadingEmployeeIds.filter((l) => l !== id),
        }
      }
    },
  },
  defaultState,
)
export default reducer

// Thunk
export function getCurrentEmployee(data) {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    dispatch(saveCurrent(data))
  }
}

export function refresh() {
  return (dispatch, getState) => {
    const storeId = getState().profile.currentStore.id
    dispatch(setLoading(true))
    apiGet(employeeApi, { storeId })
      .onOk((res) => {
        dispatch(
          setEmployees(
            res.data.response.map((e) => ({ ...e, employeeId: e.id })),
          ),
        )
      })
      .afterAll(() => {
        dispatch(setLoading(false))
      })
      .useDefaultErrorHandlers(dispatch)
      .startSingle()
  }
}

export function getEmployees() {
  return (dispatch, getState) => {
    const storeId =
      getState().profile.currentStore && getState().profile.currentStore.id
    dispatch(setLoading(true))
    apiGet(employeeApi, { storeId })
      .onOk((res) => {
        dispatch(
          setEmployees(
            res.data.response.map((e) => ({ ...e, employeeId: e.id })),
          ),
        )
      })
      .afterAll(() => {
        dispatch(setLoading(false))
      })
      .useDefaultErrorHandlers(dispatch)
      .startSingle()
  }
}

export function deleteEmployee(employeeId) {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    dispatch(setEmployeeLoading(employeeId, true))
    apiDelete(employeeApi, { employeeId })
      .onOk(() => {
        dispatch(removeEmployee(employeeId))
      })
      .afterAll(() => {
        dispatch(setEmployeeLoading(employeeId, false))
      })
      .useDefaultErrorHandlers(dispatch)
      .start()
  }
}

export function editEmployee(editedData) {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    dispatch(setEmployeeLoading(editedData.employeeId, true))
    apiPut(employeeApi, editedData)
      .onOk(() => {
        dispatch(edited())
        dispatch(refresh())
      })
      .afterAll(() => {
        dispatch(setEmployeeLoading(editedData.employeeId, false))
      })
      .useDefaultErrorHandlers(dispatch)
      .start()
  }
}

export function createEmployee(editedData) {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    dispatch(setLoading(true))
    apiPost(employeeApi, editedData)
      .onOk(() => {
        dispatch(refresh())
      })
      .afterAll(() => {
        dispatch(setLoading(false))
      })
      .useDefaultErrorHandlers(dispatch)
      .start()
  }
}

export function getEmplInfo(iin) {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    apiGet(getEmplInfoApi + "/" + iin)
      .onOk((res) => {
        dispatch(isExist(res.data.response))
      })
      .onFail((res) => {
        const r = typeof res.data.response
        if (r === "string") {
          dispatch(showMessage(res.data.response, alertTypes.error))
        } else {
          dispatch(showMessage("Введите корректный ИИН", alertTypes.error))
        }
      })
      // .useDefaultErrorHandlers(dispatch)
      .startSingle()
  }
}
